export default "__VITE_ASSET__BZdHuL8W__"